import dynamic from "next/dynamic";

export const SwitchLanguage = dynamic(() => import("./SwitchLanguage"), {
  ssr: false
});
